import React from 'react'
import _ from 'lodash'
import StorylineTableRow from '../../components/StorylineTableRow'
import '../../assets/css/pages/calendar/quest-info-panel.css'
import { getSandboxQuestDescription } from '../../util'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlus  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faMinus, faPlus)

class QuestInfoPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: true
    }
  }

  render() {
    const { sidebarAssignments, handleShowAssignmentPopup } = this.props
    let questTitle
    let questDescription
    let sandboxActivities = []
    const isSandbox = (sidebarAssignments.contentType === 'sandbox-unlock')
    const isStoryline = (sidebarAssignments.contentType === 'storyline')
    const isExpedition = (sidebarAssignments.contentType === 'expedition')

    //loading "state" in case data hasn't been fetched yet
    if (_.isEmpty(sidebarAssignments.description) && _.isEmpty(sidebarAssignments.module)) {
      questTitle = 'Loading!'
      questDescription = 'Loading!'
    }
    else if (isSandbox){
      questTitle = `Sandbox-unlock quest: ${sidebarAssignments.module.sandboxName}`
      questDescription = getSandboxQuestDescription(
                          sidebarAssignments.description,
                          sidebarAssignments.module.sandboxName)
      sandboxActivities = sidebarAssignments.module.sandboxActivities
    }
    else if(isExpedition){
      questTitle = `Expedition: ${sidebarAssignments.title}`
      questDescription = sidebarAssignments.description
    }
    else {
      questTitle = 'Quest: ' + sidebarAssignments.title
      questDescription = sidebarAssignments.description
    }
    return(
      <div className='quest-info-panel'>
        <div className='panel-header'>
          <p className='panel-title'>{questTitle}</p>
          <span className='panel-minimize' onClick={()=> this.setState({ isOpen: !this.state.isOpen })}>
            <FontAwesomeIcon icon={this.state.isOpen ? 'minus': 'plus'}/>
          </span>
        </div>
        {this.state.isOpen &&
          <div className= {'panel-body'}>
            <div className='panel-section quest-description'>
              <p className='panel-subtitle'>What's In the {`${isExpedition? 'Expedition': 'Quest'}`}</p>
              <p className='panel-contents'>{questDescription}</p>
            </div>
            {isStoryline &&
              <div className='storyline-information'>
                <div className='panel-section'>
                  <p className='panel-subtitle'>{"Storyline: " + sidebarAssignments.selectedSequenceTitle}</p>
                    {(!_.isEmpty(sidebarAssignments.selectedSequenceQuests)) && _.map(sidebarAssignments.selectedSequenceQuests, (quest,index) =>
                      <StorylineTableRow key={index} quest={quest} assignmentCount={quest.assignmentCount} handleQuestClick={handleShowAssignmentPopup}/>
                    )}
                </div>
                <div className='panel-section'>
                  <p className='panel-subtitle'>Supplemental Materials</p>
                  {sidebarAssignments  && sidebarAssignments.sequenceTeachingLink ? <a href={sidebarAssignments.sequenceTeachingLink} target='_blank' className='panel-contents panel-link'>Teacher's Guide</a> : 'Teaching guide coming soon!'}
                </div>
              </div>
            }
            {isSandbox &&
              <div className='sandbox-information'>
                <div className='panel-section'>
                  <p className='panel-subtitle'>Sandbox Activities</p>
                    {_.isEmpty(sandboxActivities) && <p className='panel-contents'> Content Coming Soon!</p>}
                    { sidebarAssignments && _.map(sandboxActivities, (activity,index) =>
                      <a href={activity.driveLink} target='_blank' className='panel-link panel-list-item' key={`${activity.title}-${index}`}>{activity.title}</a>
                    )}
                </div>
              </div>
            }
          </div>
        }
      </div>
    )
  }
}

export default QuestInfoPanel
